module.exports = __webpack_public_path__ + "static/img/bc_qt_2.b094b675.png";